import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_19 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_20 = { class: "indicator-label" }
const _hoisted_21 = { class: "indicator-progress" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_24 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ire_create_sizes",
  "aria-expanded": "true",
  "aria-controls": "kt_ire_create_sizes"
}
const _hoisted_25 = { class: "card-title m-0" }
const _hoisted_26 = { class: "fw-bolder m-0" }
const _hoisted_27 = {
  id: "kt_ire_create_sizes",
  class: "collapse show"
}
const _hoisted_28 = { class: "card-body border-top p-9" }
const _hoisted_29 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_30 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_31 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "fs-6 text-gray-600" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col fv-row" }
const _hoisted_36 = { class: "py-0" }
const _hoisted_37 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_38 = ["href", "aria-controls"]
const _hoisted_39 = { class: "me-3 rotate-90" }
const _hoisted_40 = { class: "svg-icon svg-icon-3" }
const _hoisted_41 = { class: "me-3" }
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = { class: "text-gray-800 fw-bolder" }
const _hoisted_44 = ["id"]
const _hoisted_45 = { class: "d-flex flex-wrap py-5" }
const _hoisted_46 = { class: "flex-equal me-5" }
const _hoisted_47 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_48 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_52 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_53 = { class: "flex-equal" }
const _hoisted_54 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_57 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_59 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "indicator-label" }
const _hoisted_62 = { class: "indicator-progress" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_64 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_65 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ire_property_age",
  "aria-expanded": "true",
  "aria-controls": "kt_ire_property_age"
}
const _hoisted_66 = { class: "card-title m-0" }
const _hoisted_67 = { class: "fw-bolder m-0" }
const _hoisted_68 = {
  id: "kt_ire_property_age",
  class: "collapse show"
}
const _hoisted_69 = { class: "card-body border-top p-9" }
const _hoisted_70 = {
  key: 0,
  class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_71 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_72 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_73 = { class: "fw-bold" }
const _hoisted_74 = { class: "fs-6 text-gray-600" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col fv-row" }
const _hoisted_77 = { class: "py-0" }
const _hoisted_78 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_79 = ["href", "aria-controls"]
const _hoisted_80 = { class: "me-3 rotate-90" }
const _hoisted_81 = { class: "svg-icon svg-icon-3" }
const _hoisted_82 = { class: "me-3" }
const _hoisted_83 = { class: "d-flex align-items-center" }
const _hoisted_84 = { class: "text-gray-800 fw-bolder" }
const _hoisted_85 = ["id"]
const _hoisted_86 = { class: "d-flex flex-wrap py-5" }
const _hoisted_87 = { class: "flex-equal me-5" }
const _hoisted_88 = { class: "table table-flush fw-bold gy-1" }
const _hoisted_89 = { class: "text-muted min-w-125px w-125px" }
const _hoisted_90 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)
const _hoisted_92 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { class: "indicator-label" }
const _hoisted_95 = { class: "indicator-progress" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewIreArea')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.ireAreaSchema
            }, {
              default: _withCtx(({ values }) => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedArea,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedArea) = $event)),
                        requierd: true,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('sort')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "sort",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('sort'),
                        "onUpdate:modelValue": ($event: any) => (values.sort = Number(values.sort))
                      }, null, 8, ["placeholder", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "sort" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('customUpdatedAt')) + ": ", 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "customUpdatedAt",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid"
                      })
                    ])
                  ])
                ]),
                (!_ctx.createdArea)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("button", {
                        type: "reset",
                        class: "btn btn-white btn-active-light-primary me-2",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                      }, _toDisplayString(_ctx.translate('discard')), 1),
                      _createElementVNode("button", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate('saveChanges')), 1),
                        _createElementVNode("span", _hoisted_21, [
                          _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                          _hoisted_22
                        ])
                      ], 512)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.translate('IreAvailableSizes')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (!_ctx.createdArea)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.translate('savingIreAvailableSizesNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizeOptions, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_ire_size_${index}`,
                            "aria-controls": `kt_ire_size_${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "true"
                          }, [
                            _createVNode(_component_Field, {
                              class: "form-check-input",
                              name: "isEnabled",
                              type: "checkbox",
                              value: true,
                              checked: item.isEnabled,
                              modelValue: item.isEnabled,
                              "onUpdate:modelValue": ($event: any) => ((item.isEnabled) = $event)
                            }, null, 8, ["checked", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", _hoisted_40, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, _toDisplayString(item.title), 1)
                              ])
                            ])
                          ], 8, _hoisted_38)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_ire_size_${index}`,
                          class: "fs-6 ps-10 collapse",
                          "data-bs-parent": "#kt_property_type",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("table", _hoisted_47, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.translate('isBaseSize')), 1),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Field, {
                                        class: "form-check-input",
                                        name: "isBaseSize",
                                        type: "checkbox",
                                        value: true,
                                        modelValue: item.isBase,
                                        "onUpdate:modelValue": ($event: any) => ((item.isBase) = $event),
                                        checked: item.isBase
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "checked"])
                                    ])
                                  ]),
                                  _hoisted_49
                                ]),
                                _createElementVNode("tbody", null, [
                                  (!item.isBase)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_50, [
                                        _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.translate('percentage')), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            autocomplete: "off",
                                            class: "form-control form-control-sm form-control-solid",
                                            placeholder: _ctx.translate('percentage'),
                                            "onUpdate:modelValue": ($event: any) => ((item.percentage) = $event)
                                          }, null, 8, _hoisted_52), [
                                            [_vModelText, item.percentage]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("table", _hoisted_54, [
                                _createElementVNode("tbody", null, [
                                  (item.isBase)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                                        _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.translate('value')), 1),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            autocomplete: "off",
                                            class: "form-control form-control-sm form-control-solid",
                                            placeholder: _ctx.translate('value'),
                                            "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
                                          }, null, 8, _hoisted_57), [
                                            [_vModelText, item.value]
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_44)
                      ]),
                      _hoisted_58
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_prices_submit",
                ref: "submitSizeButton",
                class: "btn btn-primary",
                disabled: !_ctx.createdArea,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitSizeOptions && _ctx.onSubmitSizeOptions(...args)))
              }, [
                _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_62, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_63
                ])
              ], 8, _hoisted_60)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('create', 'instant-rent-estimator'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("h3", _hoisted_67, _toDisplayString(_ctx.translate('IrePropertyAge')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              (!_ctx.createdArea)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("span", _hoisted_71, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.translate('savingIreAvailablePropertyAgeNote')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyAgeOptions, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", {
                            class: "d-flex align-items-center collapsible rotate collapsed",
                            href: `#kt_property_type_${index}`,
                            "aria-controls": `kt_property_type_${index}`,
                            "data-bs-toggle": "collapse",
                            role: "button",
                            "aria-expanded": "true"
                          }, [
                            _createElementVNode("div", _hoisted_80, [
                              _createElementVNode("span", _hoisted_81, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_82, [
                              _createElementVNode("div", _hoisted_83, [
                                _createElementVNode("div", _hoisted_84, _toDisplayString(item.title), 1)
                              ])
                            ])
                          ], 8, _hoisted_79)
                        ]),
                        _createElementVNode("div", {
                          id: `kt_property_type_${index}`,
                          class: "fs-6 ps-10 collapse",
                          "data-bs-parent": "#kt_property_type",
                          style: {}
                        }, [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("table", _hoisted_88, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_89, _toDisplayString(_ctx.translate('price')), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        autocomplete: "off",
                                        class: "form-control form-control-sm form-control-solid",
                                        placeholder: _ctx.translate('price'),
                                        "onUpdate:modelValue": ($event: any) => ((item.price) = $event)
                                      }, null, 8, _hoisted_90), [
                                        [_vModelText, item.price]
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 8, _hoisted_85)
                      ]),
                      _hoisted_91
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_appraiser_create_prices_submit",
                ref: "submitPropertyAgeButton",
                class: "btn btn-primary",
                disabled: !_ctx.createdArea,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmitAgeOptions && _ctx.onSubmitAgeOptions(...args)))
              }, [
                _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_95, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_96
                ])
              ], 8, _hoisted_93)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}